export const SET_KYC_DATA = "SET_KYC_DATA";
export const CIBA_LIST_FETCHING_INIT = "CIBA_LIST_FETCHING_INIT";

const initialState = {
  //######################
  //CIBA -> Session List #
  //######################
  isListLoading: false,
  search: "",
  page: 1,
  perPage: 20,
  listRefetch: false,
  listRefetchForce: false,
  totalRecords: 0,
  sessionList: [],
  //CIBA -> Edit Modal
  isEditModalOpen: false,
  disableEditSessionButton: false,
  editSessionDetails: [],
  editAccess: false,
  editedSessionName: "",
  //CIBA -> Delete Modal
  isDeleteMOdalOpen: false,
  DeleteSessionDetails: {},
  deleteSubmitDisable: false,
  //CIBA ->  Create Modal
  isModalOpen: false,
  //CIBA -> Create Modal -> step1 (Session Details)
  step1Complete: false,
  hasActiveSession: null,
  SessionFile: null,
  disableAddButton: false,
  currentSessionName: "",
  reportTypes: [],
  selectedReportDetailed: {},
  selectedReportKey: "Customer Level Cisco Smart IB Report",
  currentSessionDate: "",
  selectedDistributerKey: "",
  distributerList: [],
  //CIBA -> Create Modal -> step2 (File Upload)
  uploadProgress: 0,
  //######################
  //CIBA -> Summary Page #
  //######################
  isSummaryLoading: false,
  invalidLink: false,
  summaryData: [],
  summaryPlanPage: 1,
  totalSummaryData: 0,
  summarySessionInfo: {},
  initialSessionListLoading: true,
  initialSummaryLoading: true,

  tokenPopUp: false,
  perReportToken: 0,
  dataLoading: true,
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_KYC_DATA: {
      return { ...state, ...action.payload };
    }
    case CIBA_LIST_FETCHING_INIT: {
      return {
        ...state,
        listRefetch: false,
        listRefetchForce: false,
        isListLoading: true,
      };
    }
    default:
      return state;
  }
};
